/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useContext } from 'react';
import { ARMcontext, useViewport } from '../../../utils/context/context';
import {
  ActionItemCard,
  ActionItemCardTop,
  ActionItemCardTopSubtitle,
  ActionItemCardTopTitle,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableColumn,
  TableHeader,
  RowDiv,
  PlayerImage,
  TextZone,
  ActionItemCardTopNumber,
  TableDiv,
} from './styles';
import personIcon from '../../../assets/icons/User_svg.svg';
import { Oval } from '../styles';
import { capitalizeFirstLetters } from '../../../utils/hooks/text-formatter';
import DefaultAvatar from '../../../assets/icons/defaultAvatar.png';
import { Teams } from '../../../utils/api';
import { useLocation, useNavigate } from 'react-router-dom';

export default ({
  type,
  rows,
  hoverLocation,
  hideTooltip,
  filter
}: {
  type: string,
  rows: any,
  hoverLocation?: any,
  hideTooltip?: any,
  filter: string,
}) => {
  const { width } = useViewport();
  const cardRef = useRef<HTMLTableElement | any>(document.createElement('table'));
  const { HandleSelectedPlayer } = useContext(ARMcontext);
  const TEAMS = new Teams();
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.split("/");

  useEffect(() => {
    if (rows.length) {
      let columns = cardRef.current.children[1].children[0].children;
      let widths: string[] = [];
      for (let item of columns) {
        widths.push(item.clientWidth);
      }
      let headers = cardRef.current.children[0].children[0].children;
      for (let i = 0; i < headers.length; i++) {
        headers[i].style.width = widths[i] + 'px';
      }
    }
  }, [width]);

  function parseDateActionItems(date: string) {
    let nDate = new Date(date);
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[nDate.getMonth()] + " " + nDate.getUTCDate() + " " + String(nDate.getFullYear());
  }

  function parseZones(zone: string) {
    let newZone;
    if (zone === 'zone 1') {
      newZone = 'watch';
    }
    else if (zone === 'zone 2') {
      newZone = 'warning';
    }
    else {
      newZone = 'medical';
    }
    return newZone;
  }

  function onlyCapitalLetters(str: string) {
    return str.split('').filter(a => a.match(/[A-Z]/)).join('')
  }

  function longMetrics(metrics: any) {
    let str = '';
    if (metrics.length < 4) {
      metrics.map((metric, index) => str += index < metrics.length - 1 ? metric + ", " : metric);
    }
    else {
      metrics.map((metric, index) => str += index < metrics.length - 1 ? onlyCapitalLetters(metric) + ", " : onlyCapitalLetters(metric));

    }
    return str;
  }

  async function fetchSelectedPlayerInfo(player_id: string) {
    const playerInfo = await TEAMS.FetchSelectedPlayerInfo(player_id);
    if (playerInfo.success) {
      let section: string = path[path.length - 1];
      if (section.includes("actionItems") || section.includes("keyMetrics")) {
        navigate("/players/exams")
      }
      HandleSelectedPlayer(playerInfo.data);
    }
  }

  function PlayerColumn({ player }: { player: any }) {
    return (
      <RowDiv justifyContent="flex-start" onClick={() => fetchSelectedPlayerInfo(player._id)} style={{ cursor: 'pointer' }}>
        <PlayerImage src={player.picture ? player.picture : DefaultAvatar} alt={'playerImg'} />
        {player.firstName + " " + player.lastName}
      </RowDiv>
    )
  }

  return (
    <ActionItemCard>
      {type === 'armSoreness' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Arm Soreness</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Any arm feels tight or sore</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>Arm</TableHeader>
                  <TableHeader>Location</TableHeader>
                  <TableHeader>Body</TableHeader>
                  <TableHeader>Sleep</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.date)}</TableColumn>
                      <TableColumn>
                        <RowDiv>
                          {row.armText}
                          <TextZone marginLeft={'6px'} color={row.armText}>{row.armNumber}</TextZone>
                        </RowDiv>
                      </TableColumn>
                      <TableColumn
                        onMouseOver={(event) => row.location?.length > 3 ? hoverLocation(event, row?.location) : undefined}
                        onMouseOut={row?.location?.length > 3 ? hideTooltip : undefined}>
                        {row?.location?.length ? longMetrics(row.location) : '-'}
                      </TableColumn>
                      <TableColumn>{row.body}</TableColumn>
                      <TableColumn>{row.sleep}</TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }

        </>
      ) : type === 'armReadiness' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Arm Readiness</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Any Arm Primer Alert: Watch, warning, medical</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>Alert</TableHeader>
                  <TableHeader>Test</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.date)}</TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <Oval size={'12'} color={row.alert} margin={'0px 2px 2px 0px'} />
                          {capitalizeFirstLetters(parseZones(row.alert), ' ')}
                        </RowDiv>
                      </TableColumn>
                      <TableColumn
                        onMouseOver={(event) => row.test.length > 3 ? hoverLocation(event, row.test) : undefined}
                        onMouseOut={row.test.length > 3 ? hideTooltip : undefined}>
                        {longMetrics(row.test)}
                      </TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }
        </>
      ) : type === 'armStrength' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Arm Strength</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Where to increase strength</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>IR</TableHeader>
                  <TableHeader>ER</TableHeader>
                  <TableHeader>TS</TableHeader>
                  <TableHeader>S</TableHeader>
                  <TableHeader>GR</TableHeader>
                  <TableHeader>No.</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.date)}</TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <TextZone padding={row.ir && "2px 6px"} color={row.irStatus}>{row.ir && row.ir + '%'}</TextZone>
                        </RowDiv>
                      </TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <TextZone padding={row.er && "2px 6px"} color={row.erStatus}>{row.er && row.er + '%'}</TextZone>
                        </RowDiv>
                      </TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <TextZone padding={row.ts && "2px 6px"} color={row.tsStatus}>{row.ts && row.ts + '%'}</TextZone>
                        </RowDiv>
                      </TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <TextZone padding={row.scaption && "2px 6px"} color={row.scaptionStatus}>{row.scaption && row.scaption + '%'}</TextZone>
                        </RowDiv>
                      </TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <TextZone padding={row.grip && "2px 6px"} color={row.gripStatus}>{row.grip && row.grip + '%'}</TextZone>
                        </RowDiv>
                      </TableColumn>
                      <TableColumn>{'(' + row.zonesNumber + ')'}</TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }
        </>
      ) : type === 'armRecovery' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Arm Recovery</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Any Arm Recovery Alert: watch, warning, medical</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>Alert</TableHeader>
                  <TableHeader>Test</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.date)}</TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <Oval size={'12'} color={row.alert} margin={'0px 2px 2px 0px'} />
                          {capitalizeFirstLetters(parseZones(row.alert), ' ')}
                        </RowDiv>
                      </TableColumn>
                      <TableColumn
                        onMouseOver={(event) => row.test.length > 3 ? hoverLocation(event, row.test) : undefined}
                        onMouseOut={row.test.length > 3 ? hideTooltip : undefined}>
                        {longMetrics(row.test)}
                      </TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }
        </>
      ) : type === 'svr' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Strength Velocity Ratio</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Velocity Program Readiness</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>SVR Ratio</TableHeader>
                  <TableHeader>Alert</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.date)}</TableColumn>
                      <TableColumn>{row.ratio}</TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <Oval size={'12'} color={row.alert} margin={'0px 2px 2px 0px'} />
                          {capitalizeFirstLetters(parseZones(row.alert), ' ')}
                        </RowDiv>
                      </TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }
        </>
      ) : type === 'trainingAccountability' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Training Accountability</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Training Alerts= less than 3 days</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Last Training Day</TableHeader>
                  <TableHeader>Last 7 Days</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.lastTrainingDay)}</TableColumn>
                      <TableColumn>{row.last7Days}</TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }
        </>
      ) : type === 'armFatigue' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Arm Fatigue</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Reduce high intent workload</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>Fresh</TableHeader>
                  <TableHeader>Alert</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.date)}</TableColumn>
                      <TableColumn>{row.ratio}%</TableColumn>
                      <TableColumn>
                        <RowDiv>
                          <Oval size={'12'} color={row.alert} margin={'0px 2px 2px 0px'} />
                          {capitalizeFirstLetters(parseZones(row.alert), ' ')}
                        </RowDiv>
                      </TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }
        </>
      ) : type === 'examAccountability' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Exam Accountability</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Exam Alerts- Needs to take exam today (or late taking exam)</ActionItemCardTopSubtitle>
          {rows.length ?
            (<Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Last Fresh Exam</TableHeader>
                  <TableHeader>Days without exams</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el?.player.firstName || '';
                    const playerLast: string = el?.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  ?.map((row, index) => {
                    return (
                      <TableRow key={index}>
                        <TableColumn>
                          <PlayerColumn player={row.player} />
                        </TableColumn>
                        <TableColumn>{parseDateActionItems(row.lastFresh)}</TableColumn>
                        <TableColumn>{row.daysWithoutExam}</TableColumn>
                      </TableRow>
                    )
                  })}
              </TableBody>
            </Table>) :
            (<TableDiv>No Data</TableDiv>)
          }
        </>
      ) : type === 'medicalAlerts' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Medical Alerts</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Any arm feels tight or sore</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Last Fresh Exam Day</TableHeader>
                  <TableHeader>Reason</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.lastFresh)}</TableColumn>
                      <TableColumn
                        onMouseOver={(event) => row.reason.length > 3 ? hoverLocation(event, row.reason) : undefined}
                        onMouseOut={row.reason.length > 3 ? hideTooltip : undefined}>
                        {longMetrics(row.reason)}
                      </TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }
        </>
      ) : type === 'personalRecords' ? (
        <>
          <ActionItemCardTop>
            <ActionItemCardTopTitle>Personal Records - PR</ActionItemCardTopTitle>
            <img src={personIcon} alt='personIcon' />
            <ActionItemCardTopNumber>{rows.length}</ActionItemCardTopNumber>
          </ActionItemCardTop>
          <ActionItemCardTopSubtitle>Any PR after the first result (velocity, strength)</ActionItemCardTopSubtitle>
          {rows.length ?
            <Table ref={cardRef}>
              <TableHead>
                <TableRow width={'calc( 100% - 12px )'}>
                  <TableHeader>Players</TableHeader>
                  <TableHeader>Date</TableHeader>
                  <TableHeader>Category</TableHeader>
                  <TableHeader>Result</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows
                  .filter(el => {
                    const playerName: string = el.player.firstName || '';
                    const playerLast: string = el.player.lastName || '';
                    const name = `${playerName} ${playerLast}`;
                    return name.toLocaleLowerCase().includes(filter.toLowerCase());
                  })
                  .map((row, index) =>
                    <TableRow key={index}>
                      <TableColumn>
                        <PlayerColumn player={row.player} />
                      </TableColumn>
                      <TableColumn>{parseDateActionItems(row.date)}</TableColumn>
                      <TableColumn>{row.category}</TableColumn>
                      <TableColumn>{row.result}</TableColumn>
                    </TableRow>
                  )}
              </TableBody>
            </Table> :
            <TableDiv>No Data</TableDiv>
          }
        </>
      ) : (
        <>
        </>
      )}
    </ActionItemCard>
  );
};
